class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-link");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    document.dispatchEvent(new CustomEvent("wiq:cart:rendered"));

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

// MI dev upsell Cart
class UpsellAddToCart extends HTMLElement {
  constructor() {
    super();
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    this.submitButton = this.querySelector("[wiq-addto-cart]");
    this.selectV = this.querySelector("[data-product-select-mi]");
    this.submitButton.addEventListener("click", this.addToCart.bind(this));
  }

  addToCart(event) {
    event.preventDefault();
    this.submitButton.setAttribute("disabled", "");

    const items = [
      {
        id: this.selectV.value,
        quantity: 1,
      },
    ];

    fetch(window.routes.cart_add_url + ".js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: items,
        sections: this.cart.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        this.cart.renderContents(response);
        // document.dispatchEvent(new CustomEvent("buildCart:drawer:open")); // Open cart drawer upon success
        // this.hideUpsellProducts(); // Check upsell products after adding to cart
      })
      .finally(() => {
        this.submitButton.removeAttribute("disabled"); // Re-enable the button
      });
  }

  // hideUpsellProducts() {
  //   // Collect all product titles in the cart
  //   const cartItems = document.querySelectorAll("[data-cart-product-title]");
  //   const cartTitles = Array.from(cartItems).map((item) => item.getAttribute("data-cart-product-title"));

  //   // Hide upsell products if they match cart titles
  //   const upsellItems = document.querySelectorAll("[data-upsell-product-title]");
  //   upsellItems.forEach((upsellItem) => {
  //     const upsellTitle = upsellItem.getAttribute("data-upsell-product-title");
  //     if (cartTitles.includes(upsellTitle)) {
  //       upsellItem.classList.add("hide-product");
  //     } else {
  //       upsellItem.classList.remove("hide-product");
  //     }
  //   });

  //  hideUpsellProducts() {
  //   // Collect all product titles in the cart
  //   const cartItems = document.querySelectorAll("[data-cart-product-title]");
  //   const cartTitles = Array.from(cartItems).map((item) => item.getAttribute("data-cart-product-title"));

  //   // Track upsell products to hide duplicates
  //   const displayedUpsellTitles = new Set();

  //   // Hide upsell products if they match cart titles or are duplicates
  //   const upsellItems = document.querySelectorAll("[data-upsell-product-title]");
  //   upsellItems.forEach((upsellItem) => {
  //     const upsellTitle = upsellItem.getAttribute("data-upsell-product-title");

  //     if (cartTitles.includes(upsellTitle) || displayedUpsellTitles.has(upsellTitle)) {
  //       // Hide if the product is in the cart or is a duplicate
  //       upsellItem.classList.add("hide-product");
  //     } else {
  //       // Show the product and mark it as displayed
  //       upsellItem.classList.remove("hide-product");
  //       displayedUpsellTitles.add(upsellTitle);
  //     }
  //   });

  //   const isAllUpsellsHidden = Array.from(upsellItems).every((item) =>
  //     item.classList.contains("hide-product")
  //   );

  //   // Hide the upsell header if all upsell items are hidden
  //   const upsellHeader = document.querySelector(".drawer_cart-upsell-header");
  //   if (upsellHeader) {
  //     if (isAllUpsellsHidden) {
  //       upsellHeader.style.display = "none";
  //     } else {
  //       upsellHeader.style.display = "block";
  //     }
  //   }

  // }
}

customElements.define("upsell-addto-cart", UpsellAddToCart);
